const image_path = 'https://image.tmdb.org/t/p/w500'

export const ApiImage = image_path